import { FunctionComponent, h, VNode, PreactDOMAttributes } from 'preact';
import { StyledInput } from './input-field.styles';

export interface InputProps extends PreactDOMAttributes {
  onChange: (event: Event) => void;
  className?: string;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  children?: string | VNode | VNode[];
  value?: string;
}

const InputField: FunctionComponent<InputProps> = ({
  className = '',
  disabled = false,
  error,
  children,
  ...otherProps
}) => {
  return (
    <StyledInput className={className} disabled={disabled} $error={error ?? false} {...otherProps}>
      {children}
    </StyledInput>
  );
};

export default InputField;
